import {useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import CustomLoader from "../../../util/component/CustomLoader";

export enum OidcProvider {
    ADFS = "ADFS",
    TRUSTBUILDER = "TRUSTBUILDER"
}

const AdfsLoginPage = () => {

    const {globalData} = useContext(GlobalContext);
    const navigate = useNavigate();
    const pathOrigin = window.location.origin;

    function generateRandomString(length: number): string {
        const array = new Uint8Array(length);
        window.crypto.getRandomValues(array);
        return Array.from(array, byte => ('0' + (byte % 36).toString(36)).slice(-1)).join('');
    }


    useEffect(() => {
        if (globalData.user) {
            navigate("/");
        } else {
            // @ts-ignore
            let url = `${window?.appConfig?.ADFS_BASE_URL}`;
            url += "/authorize";
            url += "?response_type=code";
            // @ts-ignore
            if (OidcProvider.ADFS === window?.appConfig?.OIDC_PROVIDER) {
                // @ts-ignore
                if (pathOrigin === `${window?.appConfig?.ADFS_ORIGIN}`) {
                    // @ts-ignore
                    url += "&resource=" + `${window?.appConfig?.ADFS_RESOURCE_ID}`;
                    // @ts-ignore
                    url += "&client_id=" + `${window?.appConfig?.ADFS_CLIENT_ID}`;
                    // @ts-ignore
                    url += "&redirect_uri=" + `${window?.appConfig?.ADFS_REDIRECT_URI}`;
                    // @ts-ignore
                } else if (pathOrigin === `${window?.appConfig?.ADFS_INTRA_ORIGIN}`) {
                    // @ts-ignore
                    url += "&resource=" + `${window?.appConfig?.ADFS_INTRA_RESOURCE_ID}`;
                    // @ts-ignore
                    url += "&client_id=" + `${window?.appConfig?.ADFS_INTRA_CLIENT_ID}`;
                    // @ts-ignore
                    url += "&redirect_uri=" + `${window?.appConfig?.ADFS_INTRA_REDIRECT_URI}`;
                }
                // @ts-ignore
            } else if (OidcProvider.TRUSTBUILDER === window?.appConfig?.OIDC_PROVIDER) {
                // @ts-ignore
                if (pathOrigin === `${window?.appConfig?.ADFS_ORIGIN}`) {
                    // @ts-ignore
                    url += "&scope=" + `${window?.appConfig?.ADFS_SCOPE}`;
                    // @ts-ignore
                    url += "&client_id=" + `${window?.appConfig?.ADFS_CLIENT_ID}`;
                    // @ts-ignore
                    url += "&redirect_uri=" + `${window?.appConfig?.ADFS_REDIRECT_URI}`;
                    // @ts-ignore
                } else if (pathOrigin === `${window?.appConfig?.ADFS_INTRA_ORIGIN}`) {
                    // @ts-ignore
                    url += "&scope=" + `${window?.appConfig?.ADFS_INTRA_SCOPE}`;
                    // @ts-ignore
                    url += "&client_id=" + `${window?.appConfig?.ADFS_INTRA_CLIENT_ID}`;
                    // @ts-ignore
                    url += "&redirect_uri=" + `${window?.appConfig?.ADFS_INTRA_REDIRECT_URI}`;
                }
                url += "&nonce=" + `${Date.now()}-${generateRandomString(8)}`;
            }

            window.location.href = url;
        }

    }, []);


    return (<CustomLoader loading={true}/>);
}

export default AdfsLoginPage;
